import Icon from '../components/Icon.vue'

Icon.register({"sort-up":{"width":320,"height":512,"paths":[{"d":"M279 224H41C19.6 224 8.9 198.1 24 183L143 64C152.4 54.6 167.6 54.6 176.9 64L295.9 183C311.1 198.1 300.4 224 279 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-up.js
// module id = 4xBM
// module chunks = 0